/**
 * Shopify Unlimited Yoga Upsell
 * Shows upsell to add Unlimited package when individual courses are added
 */

(function() {
  'use strict';

  console.log('🧘 Unlimited Upsell Starting...');

  const UNLIMITED_HANDLE = 'yogabondance';
  const UNLIMITED_PRICE = 42000; // $420 in cents
  const DEBUG = false; // Set to true for debugging

  // ============================================================================
  // VISIBLE CONSOLE LOGGING (for debugging in Shopify)
  // ============================================================================
  let visibleConsole = null;

  function createVisibleConsole() {
    if (visibleConsole) return;

    visibleConsole = document.createElement('div');
    visibleConsole.id = 'upsell-visible-console';
    visibleConsole.style.cssText = `
      position: fixed;
      bottom: 0;
      right: 0;
      width: 500px;
      max-height: 400px;
      background: rgba(0, 0, 0, 0.95);
      color: #00ff00;
      font-family: monospace;
      font-size: 11px;
      padding: 10px;
      overflow-y: auto;
      z-index: 999999;
      border-top-left-radius: 8px;
    `;
    document.body.appendChild(visibleConsole);
  }

  function visibleLog(...args) {
    console.log(...args);
    createVisibleConsole();
    const message = args.map(arg =>
      typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
    ).join(' ');
    const line = document.createElement('div');
    line.textContent = `[${new Date().toLocaleTimeString()}] ${message}`;
    line.style.borderBottom = '1px solid #333';
    line.style.paddingBottom = '3px';
    line.style.marginBottom = '3px';
    visibleConsole.appendChild(line);
    visibleConsole.scrollTop = visibleConsole.scrollHeight;
  }

  // ============================================================================
  // PRODUCT ADDED CONFIRMATION MODAL
  // ============================================================================
  function showProductAddedConfirmation() {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      z-index: 999998;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    // Create modal
    const modal = document.createElement('div');
    modal.style.cssText = `
      background: white;
      padding: 40px;
      border-radius: 12px;
      max-width: 500px;
      width: 90%;
      box-shadow: 0 10px 40px rgba(0,0,0,0.3);
      text-align: center;
      position: relative;
    `;

    modal.innerHTML = `
      <div style="font-size: 48px; margin-bottom: 20px;">✅</div>
      <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #4CAF50;">
        Produit ajouté au panier !
      </h2>
      <p style="font-size: 16px; color: #666; margin-bottom: 25px;">
        Votre produit a été ajouté au panier avec succès.
      </p>
      <button id="close-confirmation-upsell" style="
        background: #4CAF50;
        color: white;
        border: none;
        padding: 15px 30px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        transition: background 0.3s;
      ">
        Continuer
      </button>
    `;

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Close button handler
    const closeBtn = document.getElementById('close-confirmation-upsell');
    closeBtn.addEventListener('click', () => {
      overlay.remove();
      window.location.reload();
    });

    closeBtn.addEventListener('mouseenter', () => {
      closeBtn.style.background = '#45a049';
    });
    closeBtn.addEventListener('mouseleave', () => {
      closeBtn.style.background = '#4CAF50';
    });

    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.remove();
        window.location.reload();
      }
    });

    // Auto-close after 3 seconds and reload
    setTimeout(() => {
      if (overlay.parentNode) {
        overlay.remove();
      }
      window.location.reload();
    }, 3000);
  }

  // Make it globally available
  window.showProductAddedConfirmation = showProductAddedConfirmation;

  // Upgrade variant mapping: upgrade price -> variant title to search for
  // Two products to cover full price range (Shopify 250 variant limit)
  const UNLIMITED_UPGRADE_HANDLE_LOW = 'acces-illimite-surclassement'; // $1-$249
  const UNLIMITED_UPGRADE_HANDLE_HIGH = 'yogabondance-upgrade'; // $250-$450
  const UNLIMITED_UPGRADE_HANDLE = 'yogabondance-upgrade'; // Legacy reference

  // ============================================================================
  // EXCLUSION CONFIGURATION
  // ============================================================================
  // You can exclude products from the upsell in 5 ways:

  // 1. By Individual Product Handle
  // Products excluded from upsell (won't trigger the upsell modal)
  const EXCLUDED_FROM_UPSELL = [
    'carte-cadeau',  // Gift card
    'acces-illimite-surclassement',  // Upgrade product (low range)
    'yogabondance-upgrade',  // Upgrade product (high range)
    'yogabondance',  // Unlimited product
  ];

  // 1b. By Specific Variant ID
  // Specific variant IDs excluded from upsell (for excluding individual variants)
  const EXCLUDED_VARIANT_IDS = [
    45448446279868,
    45446239518908,
    45448451621052,
    45446226411708,
    45448441888956,
    45448436252860,
    45446232801468,
    45448434188476,
    45448447525052,
    45446223659196,
    45446229295292,
    45446240010428,
    45448417706172,
    45448444707004,
    45446230343868,
    45446229459132,
    45446229688508,
    45446224183484,
    45446240370876,
    45446232113340,
    45448438743228,
    45448446279868,
    45448448409788,
    45445922914492,
    45445446631612,
    45448449163452,
    45448443035836,
  ];

  // 2. By Product Type (EASIEST - Excludes entire categories!)
  // Product TYPES excluded from upsell (e.g., 'Merchandise', 'Gift Card')
  const EXCLUDED_PRODUCT_TYPES = [
    // 'Merchandise',
    // 'Gift Card',
    // 'Physical Product',
  ];

  // 3. By Product Tags
  // Product TAGS excluded from upsell (e.g., 'no-upsell', 'physical-product')
  const EXCLUDED_TAGS = [
    'ateliers',
    'atelier',
    'no-limit',
    // 'no-upsell',
    // 'physical-product',
  ];

  // 4. By Collection Handle (Excludes products in specific collections)
  // Collection handles to exclude from upsell
  const EXCLUDED_COLLECTIONS = [
    'ateliers-et-evenements',
  ];

  // Collection IDs to exclude from upsell (optional, backup method)
  const EXCLUDED_COLLECTION_IDS = [
    312569430204,
  ];

  // Cache for collection checks
  const upsellCollectionCache = {};

  // Quick synchronous check for exclusions (no async operations)
  function isExcludedFromUpsellSync(item) {
    // Validate item
    if (!item || !item.handle) {
      console.log('⚠️ Invalid item for exclusion check');
      return false;
    }

    // Check by variant ID first (most specific)
    if (item.variant_id && EXCLUDED_VARIANT_IDS.includes(item.variant_id)) {
      console.log('❌ Excluded by variant ID:', item.variant_id);
      return true;
    }

    // Also check item.id in case variant_id isn't set
    if (item.id && EXCLUDED_VARIANT_IDS.includes(item.id)) {
      console.log('❌ Excluded by variant ID (item.id):', item.id);
      return true;
    }

    // Check by handle
    if (EXCLUDED_FROM_UPSELL.includes(item.handle)) {
      console.log('❌ Excluded by handle:', item.handle);
      return true;
    }

    // Check by product type
    if (item.product_type && EXCLUDED_PRODUCT_TYPES.includes(item.product_type)) {
      console.log('❌ Excluded by product type:', item.product_type);
      return true;
    }

    // Check by tags (case-insensitive)
    // Tags are in the item data from cart API
    if (item.tags) {
      // Handle both array format and string format
      const tags = Array.isArray(item.tags) ? item.tags : item.tags.split(', ');

      for (const tag of tags) {
        const tagLower = tag.trim().toLowerCase();
        for (const excludedTag of EXCLUDED_TAGS) {
          if (tagLower === excludedTag.toLowerCase()) {
            console.log('❌ Excluded by tag (sync):', tag);
            return true;
          }
        }
      }
    }

    return false;
  }

  // Async check for exclusions (fetches product data if needed)
  async function isExcludedFromUpsell(item) {
    // First do synchronous checks
    if (isExcludedFromUpsellSync(item)) {
      return true;
    }

    // Check by collection (only if configured)
    if (EXCLUDED_COLLECTIONS.length === 0 && EXCLUDED_COLLECTION_IDS.length === 0) {
      return false;
    }

    // Check cache first
    if (upsellCollectionCache[item.handle] !== undefined) {
      console.log('📦 Using cached collection check for:', item.handle);
      return upsellCollectionCache[item.handle];
    }

    try {
      // Fetch product page HTML
      console.log('🔍 Fetching product page for collection check:', item.handle);
      const htmlResponse = await originalFetch(`/products/${item.handle}`);
      const html = await htmlResponse.text();

      // Method 1: Look for collection links in breadcrumbs
      const breadcrumbMatch = html.match(/<nav[^>]*(?:breadcrumb|Breadcrumb)[^>]*>[\s\S]*?<\/nav>/i);
      if (breadcrumbMatch) {
        const breadcrumbHtml = breadcrumbMatch[0];
        console.log('🍞 Found breadcrumb for upsell check');

        for (const collectionHandle of EXCLUDED_COLLECTIONS) {
          const collectionLinkRegex = new RegExp(`<a[^>]*href=["']/collections/${collectionHandle}(?:/|["'])`);
          if (collectionLinkRegex.test(breadcrumbHtml)) {
            console.log('❌ Excluded by collection in breadcrumb:', collectionHandle);
            upsellCollectionCache[item.handle] = true;
            return true;
          }
        }
      }

      // Method 2: Check structured data (JSON-LD)
      const jsonLdMatches = html.match(/<script[^>]*type=["']application\/ld\+json["'][^>]*>([\s\S]*?)<\/script>/gi);
      if (jsonLdMatches) {
        for (const scriptTag of jsonLdMatches) {
          const jsonContent = scriptTag.replace(/<script[^>]*>/, '').replace(/<\/script>/, '');
          try {
            const structuredData = JSON.parse(jsonContent);

            if (structuredData['@type'] === 'BreadcrumbList' && structuredData.itemListElement) {
              console.log('🔍 Checking structured breadcrumbs for upsell');

              for (const breadcrumbItem of structuredData.itemListElement) {
                if (breadcrumbItem.item) {
                  const itemUrl = typeof breadcrumbItem.item === 'string' ? breadcrumbItem.item : breadcrumbItem.item['@id'];
                  for (const collectionHandle of EXCLUDED_COLLECTIONS) {
                    if (itemUrl && itemUrl.includes(`/collections/${collectionHandle}`)) {
                      console.log('❌ Excluded by collection:', collectionHandle);
                      upsellCollectionCache[item.handle] = true;
                      return true;
                    }
                  }
                }
              }
            }
          } catch (e) {
            console.log('⚠️ Could not parse JSON-LD:', e);
          }
        }
      }

      // Method 3: Check canonical/alternate links
      for (const collectionHandle of EXCLUDED_COLLECTIONS) {
        const collectionPathRegex = new RegExp(`/collections/${collectionHandle}/products/${item.handle}(?:[?#/]|$)`);
        if (collectionPathRegex.test(html)) {
          console.log('❌ Excluded by collection path:', collectionHandle);
          upsellCollectionCache[item.handle] = true;
          return true;
        }
      }

      // Not excluded
      upsellCollectionCache[item.handle] = false;
      return false;
    } catch (error) {
      console.error('Error checking product collections:', error);
      // On error, assume not excluded to show upsell
      upsellCollectionCache[item.handle] = false;
      return false;
    }
  }

  // Map of upgrade prices (what customer pays) to variant titles
  // We'll search for variants by price
  const UPGRADE_PRICES = {
    4000: 'Upgrade $40',    // Customer pays $40 total
    10000: 'Upgrade $100',  // Customer pays $100 total
    15000: 'Upgrade $150',  // Customer pays $150 total
    20000: 'Upgrade $200',  // Customer pays $200 total
    26000: 'Upgrade $260'   // Customer pays $260 total
  };

  function debugLog(message) {
    if (DEBUG) console.log(message);
  }

  // Track if we're currently showing an upsell to prevent duplicates
  let upsellShowing = false;

  // Store the original fetch for cart operations
  const originalFetch = window.fetch;

  /**
   * Get product info by handle
   */
  async function getProductByHandle(handle) {
    try {
      const response = await originalFetch(`/products/${handle}.js`);
      const product = await response.json();
      return product;
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  /**
   * Get current cart
   */
  async function getCart() {
    try {
      const response = await originalFetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  /**
   * Add item to cart
   */
  async function addToCart(variantId, quantity = 1, properties = {}) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      // Add properties if provided
      Object.keys(properties).forEach(key => {
        formData.append(`properties[${key}]`, properties[key]);
      });

      console.log('📤 Sending add to cart request...', { variantId, quantity, properties });

      const response = await originalFetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Upsell-Request': 'true'
        }
      });

      console.log('📨 Response status:', response.status, response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response not OK:', errorText);
        return { error: true, message: errorText };
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('❌ Error adding to cart:', error);
      return { error: true, message: error.message };
    }
  }

  /**
   * Find the correct upgrade variant by price
   * Uses two products to cover full price range (Shopify 250 variant limit)
   */
  async function getUpgradeVariant(upgradePrice) {
    try {
      console.log('🔍 Finding upgrade variant for price (cents):', upgradePrice, '($' + upgradePrice/100 + ')');

      // Choose the correct product based on price
      // $1-$249 (100-24900 cents) -> acces-illimite-surclassement
      // $250-$450 (25000-45000 cents) -> yogabondance-upgrade
      const productHandle = upgradePrice < 25000 ? UNLIMITED_UPGRADE_HANDLE_LOW : UNLIMITED_UPGRADE_HANDLE_HIGH;
      console.log('📦 Using product handle:', productHandle, '(price threshold: $250)');

      const product = await getProductByHandle(productHandle);

      console.log('📦 Upgrade product found:', product ? product.title : 'NOT FOUND');

      if (!product || !product.variants) {
        console.error('❌ Upgrade product not found or has no variants');
        console.error('Looking for handle:', productHandle);
        return null;
      }

      // Log all available variants with detailed info
      console.log('📋 Available variants (looking for ' + upgradePrice + ' cents):');
      product.variants.forEach(v => {
        const isMatch = v.price === upgradePrice;
        const diff = Math.abs(v.price - upgradePrice);
        console.log(`  - ${v.title}: ${v.price} cents ($${v.price/100}) ${isMatch ? '✅ MATCH' : '❌ diff=' + diff}`);
      });

      // Try to find exact price match
      console.log('🔎 Searching for exact match with price:', upgradePrice, '(type:', typeof upgradePrice, ')');
      let variant = product.variants.find(v => {
        console.log(`   Comparing: v.price=${v.price} (type:${typeof v.price}) === upgradePrice=${upgradePrice} (type:${typeof upgradePrice}) => ${v.price === upgradePrice}`);
        return v.price === upgradePrice;
      });

      if (!variant) {
        // Find closest price
        console.log('⚠️ No exact match for', upgradePrice, 'cents. Finding closest...');
        const variants = product.variants.sort((a, b) =>
          Math.abs(a.price - upgradePrice) - Math.abs(b.price - upgradePrice)
        );
        variant = variants[0];
        console.log(`⚠️ Using closest match: ${variant.title} at ${variant.price} cents ($${variant.price/100}) - requested ${upgradePrice} cents ($${upgradePrice/100})`);
      } else {
        console.log('✅ Exact match found!');
      }

      console.log('✅ Selected variant:', variant.title, 'ID:', variant.id, 'Price:', variant.price);
      return variant;
    } catch (error) {
      console.error('❌ Error finding upgrade variant:', error);
      return null;
    }
  }

  /**
   * Check if cart contains unlimited product
   */
  function cartHasUnlimited(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(item =>
      item.handle === UNLIMITED_HANDLE ||
      item.handle === UNLIMITED_UPGRADE_HANDLE_LOW ||
      item.handle === UNLIMITED_UPGRADE_HANDLE_HIGH
    );
  }

  /**
   * Calculate cart total excluding items that are excluded from upsell
   * (e.g., Ateliers products shouldn't count toward the unlimited upgrade calculation)
   */
  async function calculateEligibleCartTotal(cart) {
    if (!cart || !cart.items) return 0;

    let eligibleTotal = 0;

    for (const item of cart.items) {
      // If tags aren't in cart item, fetch them
      if (!item.tags || item.tags.length === 0) {
        try {
          const response = await originalFetch(`/products/${item.handle}.js`);
          const productData = await response.json();
          if (productData.tags) {
            item.tags = productData.tags;
          }
        } catch (e) {
          console.log('⚠️ Could not fetch product tags for:', item.handle);
        }
      }

      // Check if this item should be excluded from the calculation
      const isExcluded = isExcludedFromUpsellSync(item);

      if (!isExcluded) {
        // Use final_price (includes discounts) instead of price (original price)
        // This ensures automatic discounts/rebates are included in the calculation
        const itemPrice = item.final_price || item.discounted_price || item.price;
        eligibleTotal += itemPrice;
        console.log(`  Adding ${item.title}: ${itemPrice} cents ($${itemPrice/100}) ${item.final_price !== item.price ? '(discounted)' : ''}`);
      }
    }

    return eligibleTotal;
  }

  /**
   * Calculate upsell price based on item just added
   */
  function calculateUpsellPrice(itemPrice) {
    const upsellPrice = UNLIMITED_PRICE - itemPrice;
    return Math.max(0, upsellPrice); // Never negative
  }

  /**
   * Format price in cents to dollars
   */
  function formatPrice(cents) {
    return (cents / 100).toFixed(0) + '$';
  }

  /**
   * Show FREE upgrade modal (when cart exceeds $420)
   */
  function showFreeUpgradeModal(itemAdded, savings, upgradePrice) {
    console.log('🎉 showFreeUpgradeModal called');
    console.log('   upsellShowing:', upsellShowing);
    console.log('   savings:', savings);
    console.log('   upgradePrice:', upgradePrice);

    if (upsellShowing) {
      console.log('❌ Returning early - upsellShowing is true');
      return;
    }

    upsellShowing = true;

    // Get existing overlay (created in event handler) or create new one
    let overlay = document.getElementById('unlimited-upsell-overlay');
    console.log('   overlay exists?', !!overlay);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'unlimited-upsell-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999998;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      document.body.appendChild(overlay);
    }

    // Clear any existing content
    overlay.innerHTML = '';

    // Create modal
    const modal = document.createElement('div');
    modal.id = 'unlimited-upsell-modal';
    modal.style.cssText = `
      background: white;
      padding: 40px;
      border-radius: 12px;
      max-width: 600px;
      width: 90%;
      box-shadow: 0 10px 40px rgba(0,0,0,0.3);
      text-align: center;
      position: relative;
    `;

    const savingsFormatted = formatPrice(savings);

    modal.innerHTML = `
      <div style="margin-bottom: 20px;">
        <img src="https://cdn.shopify.com/s/files/1/0679/5998/0220/files/yogaillimite_24379424-a529-4a16-94d1-64b12ab9b084.png"
             alt="Yoga Illimité"
             style="width: 350px; height: auto; display: block; margin: 0 auto;">
      </div>
      <div style="font-size: 48px; margin-bottom: 15px;">🎉</div>
      <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #4CAF50;">
        Surclassement GRATUIT disponible !
      </h2>
      <p style="font-size: 14px; margin-bottom: 20px;">Fini les choix difficiles à l'inscription, la formule yoga illimitée est maintenant disponible! YogAbondance, c'est la liberté de choisir chaque jour la pratique qui nourrit le mieux le corps et l'esprit et ce, de façon illimitée.</p>
      <p style="font-size: 18px; color: #333; line-height: 1.6; margin-bottom: 25px;">
        Vous êtes éligible pour un <strong style="color: #4CAF50;">surclassement GRATUIT</strong> vers l'accès Illimité !<br><br>
        <strong style="color: #4CAF50; font-size: 24px;">Économisez ${savingsFormatted} !</strong>
      </p>
      <p style="font-size: 14px; color: #666; margin-bottom: 25px;">
        En acceptant, nous retirerons le dernier cours ajouté et vous donnerons l'accès Illimité pour le même prix que vos cours actuels.
      </p>
      <div style="display: flex; gap: 10px; justify-content: center;">
        <button id="upsell-accept" style="
          background: #4CAF50;
          color: white;
          border: none;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: background 0.3s;
        ">
          Oui, passez-moi à l'Illimité !
        </button>
        <button id="upsell-decline" style="
          background: #f5f5f5;
          color: #666;
          border: 1px solid #ddd;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s;
        ">
          Non, garder mes cours
        </button>
      </div>
    `;

    overlay.appendChild(modal);

    // Add hover effects
    const acceptBtn = document.getElementById('upsell-accept');
    const declineBtn = document.getElementById('upsell-decline');

    acceptBtn.addEventListener('mouseenter', () => {
      acceptBtn.style.background = '#45a049';
    });
    acceptBtn.addEventListener('mouseleave', () => {
      acceptBtn.style.background = '#4CAF50';
    });

    declineBtn.addEventListener('mouseenter', () => {
      declineBtn.style.background = '#e0e0e0';
    });
    declineBtn.addEventListener('mouseleave', () => {
      declineBtn.style.background = '#f5f5f5';
    });

    // Handle accept - Remove new item, add unlimited upgrade at calculated price
    acceptBtn.addEventListener('click', async () => {
      acceptBtn.disabled = true;
      acceptBtn.textContent = 'Traitement en cours...';

      try {
        // Step 1: Remove the item that was just added
        visibleLog('🗑️ Removing newly added item:', itemAdded.title);
        visibleLog('   Looking for variant_id:', itemAdded.variant_id);
        visibleLog('   itemAdded full object:');
        visibleLog(itemAdded);

        const cart = await getCart();
        visibleLog('   Current cart items:');
        cart.items.forEach(item => {
          visibleLog(`   - ${item.title} (variant_id: ${item.variant_id}, id: ${item.id}, key: ${item.key})`);
        });

        const itemToRemove = cart.items.find(i => i.variant_id === itemAdded.variant_id || i.id === itemAdded.variant_id);

        if (itemToRemove) {
          visibleLog('   Found item to remove:', itemToRemove.title);
          visibleLog('   Using key:', itemToRemove.key);
          const removeResult = await originalFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemToRemove.key,  // Use the cart line item key, not variant_id
              quantity: 0
            })
          });
          const removeData = await removeResult.json();
          visibleLog('✅ Remove response:');
          visibleLog(removeData);
        } else {
          visibleLog('❌ Item not found in cart!');
        }

        // Step 2: Add unlimited upgrade at the calculated price
        console.log('💰 Adding upgrade at price:', upgradePrice, '($' + upgradePrice/100 + ')');
        const upgradeVariant = await getUpgradeVariant(upgradePrice);

        if (!upgradeVariant) {
          console.error('❌ Could not find upgrade variant');
          alert('Produit de surclassement introuvable.');
          overlay.remove();
          upsellShowing = false;
          return;
        }

        const properties = {
          'Type': 'Surclassement Illimité GRATUIT',
          'Économies': formatPrice(savings)
        };

        const result = await addToCart(upgradeVariant.id, 1, properties);

        if (result && !result.error) {
          visibleLog('✅ Upgrade added successfully');

          // Show success message
          modal.innerHTML = `
            <div style="font-size: 48px; margin-bottom: 20px;">✅</div>
            <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #4CAF50;">
              Parfait !
            </h2>
            <p style="font-size: 16px; color: #666;">
              Vous avez été surclassé à l'accès Illimité !<br>
              Vous économisez ${savingsFormatted} !
            </p>
          `;

          setTimeout(() => {
            overlay.remove();
            upsellShowing = false;
            showProductAddedConfirmation();
          }, 1500);
        } else {
          console.error('❌ Error adding upgrade:', result);
          alert('Erreur lors de l\'ajout: ' + (result?.message || 'Erreur inconnue'));
          overlay.remove();
          upsellShowing = false;
        }
      } catch (error) {
        console.error('❌ Exception:', error);
        alert('Erreur: ' + error.message);
        overlay.remove();
        upsellShowing = false;
      }
    });

    // Handle decline - Keep the new item at full price
    declineBtn.addEventListener('click', () => {
      overlay.remove();
      upsellShowing = false;
      showProductAddedConfirmation();
    });

    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.remove();
        upsellShowing = false;
        showProductAddedConfirmation();
      }
    });
  }

  /**
   * Show upsell modal
   */
  function showUpsellModal(itemAdded, upsellPrice, cartTotal) {
    if (upsellShowing) {
      debugLog('Upsell already showing, skipping');
      return;
    }

    upsellShowing = true;
    cartTotal = cartTotal || itemAdded.price; // Fallback to item price if cart total not provided

    // Get existing overlay (created in event handler) or create new one
    let overlay = document.getElementById('unlimited-upsell-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'unlimited-upsell-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999998;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      document.body.appendChild(overlay);
    }

    // Clear any existing content
    overlay.innerHTML = '';

    // Create modal
    const modal = document.createElement('div');
    modal.id = 'unlimited-upsell-modal';
    modal.style.cssText = `
      background: white;
      padding: 40px;
      border-radius: 12px;
      max-width: 600px;
      width: 90%;
      box-shadow: 0 10px 40px rgba(0,0,0,0.3);
      text-align: center;
      position: relative;
    `;

    const upsellPriceFormatted = formatPrice(upsellPrice);
    const cartTotalFormatted = formatPrice(cartTotal);

    modal.innerHTML = `
      <div style="margin-bottom: 20px;">
        <img src="https://cdn.shopify.com/s/files/1/0679/5998/0220/files/yogaillimite_24379424-a529-4a16-94d1-64b12ab9b084.png"
             alt="Yoga Illimité"
             style="width: 350px; height: auto; display: block; margin: 0 auto;">
      </div>
      <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #333;">
        Forfait Yoga illimité
      </h2>
      <p style="font-size: 14px;">Fini les choix difficiles à l’inscription, la formule yoga illimitée est maintenant disponible! YogAbondance, c’est la liberté de choisir chaque jour la pratique qui nourrit le mieux le corps et l’esprit et ce, de façon illimitée.</p>
      <p style="font-size: 16px; color: #666; line-height: 1.6; margin-bottom: 25px;">
       <br><br>
        Ajoutez l'accès <strong>Illimité à tous les cours</strong><br>pour seulement <strong style="color: #4CAF50; font-size: 20px;">${upsellPriceFormatted} de plus</strong> !
      </p>
      <div style="margin-bottom: 25px; padding: 15px; background: #f0f8f0; border-radius: 8px; display:none;">
        <p style="margin: 0; font-size: 14px; color: #2e7d32;">
          💰 Total avec YogAbondance : ${formatPrice(UNLIMITED_PRICE)}
        </p>
      </div>
      <div style="display: flex; gap: 10px; justify-content: center;">
        <button id="upsell-accept" style="
          background: #4CAF50;
          color: white;
          border: none;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: background 0.3s;
        ">
          Oui, ajouter le forfait illimité !
        </button>
        <button id="upsell-decline" style="
          background: #f5f5f5;
          color: #666;
          border: 1px solid #ddd;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s;
        ">
          Non merci
        </button>
      </div>
    `;

    overlay.appendChild(modal);

    // Add hover effects
    const acceptBtn = document.getElementById('upsell-accept');
    const declineBtn = document.getElementById('upsell-decline');

    acceptBtn.addEventListener('mouseenter', () => {
      acceptBtn.style.background = '#45a049';
    });
    acceptBtn.addEventListener('mouseleave', () => {
      acceptBtn.style.background = '#4CAF50';
    });

    declineBtn.addEventListener('mouseenter', () => {
      declineBtn.style.background = '#e0e0e0';
    });
    declineBtn.addEventListener('mouseleave', () => {
      declineBtn.style.background = '#f5f5f5';
    });

    // Handle accept
    acceptBtn.addEventListener('click', async () => {
      acceptBtn.disabled = true;
      acceptBtn.textContent = 'Ajout en cours...';

      try {
        console.log('🔍 Calculating upgrade price');
        console.log('💰 Cart total passed to modal:', cartTotal);

        // Calculate upgrade price based on the cart total passed to the modal
        const upgradePrice = UNLIMITED_PRICE - cartTotal;

        console.log('💰 Upgrade price to find:', upgradePrice, '($' + upgradePrice/100 + ')');

        // Get the correct upgrade variant
        const upgradeVariant = await getUpgradeVariant(upgradePrice);

        if (!upgradeVariant) {
          console.error('❌ Could not find upgrade variant');
          console.error('Make sure product with handle "' + UNLIMITED_UPGRADE_HANDLE + '" exists with a variant priced at', upgradePrice);
          alert('Produit de surclassement introuvable.\n\nAssurez-vous que le produit "' + UNLIMITED_UPGRADE_HANDLE + '" existe avec une variante à ' + formatPrice(upgradePrice) + '.');
          overlay.remove();
          upsellShowing = false;
          return;
        }

        console.log('🎯 Adding upgrade variant ID:', upgradeVariant.id);

        // Add upgrade variant to cart with properties
        const properties = {
          'Type': 'Surclassement Illimité',
          'Panier original': formatPrice(cartTotal)
        };

        const result = await addToCart(upgradeVariant.id, 1, properties);

        console.log('📥 Add to cart result:', result);

        if (result && !result.error) {
          console.log('✅ Upgrade added to cart successfully');

          // Show success message
          modal.innerHTML = `
            <div style="font-size: 48px; margin-bottom: 20px;">✅</div>
            <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #4CAF50;">
              Parfait !
            </h2>
            <p style="font-size: 16px; color: #666;">
              L'accès Illimité (Surclassement) a été ajouté à votre panier !
            </p>
          `;

          // Refresh page to show updated cart
          setTimeout(() => {
            overlay.remove();
            upsellShowing = false;
            showProductAddedConfirmation();
          }, 1500);
        } else {
          console.error('❌ Error adding to cart:', result);
          alert('Erreur lors de l\'ajout: ' + (result?.message || result?.description || 'Erreur inconnue'));
          overlay.remove();
          upsellShowing = false;
        }
      } catch (error) {
        console.error('❌ Exception:', error);
        alert('Erreur lors de l\'ajout: ' + error.message);
        overlay.remove();
        upsellShowing = false;
      }
    });

    // Handle decline
    declineBtn.addEventListener('click', () => {
      overlay.remove();
      upsellShowing = false;
      // Show confirmation modal
      showProductAddedConfirmation();
    });

    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.remove();
        upsellShowing = false;
        showProductAddedConfirmation();
      }
    });
  }

  /**
   * Check if we should show upsell after adding item
   */
  async function checkAndShowUpsell(itemAdded) {
    console.log('🔍 Checking if should show upsell for:', itemAdded.handle);

    // Validate item has required properties
    if (!itemAdded || !itemAdded.handle) {
      console.log('❌ Invalid item data, no upsell');
      return false;
    }

    // Don't show upsell if the item added IS unlimited or upgrade product
    if (itemAdded.handle === UNLIMITED_HANDLE || itemAdded.handle === UNLIMITED_UPGRADE_HANDLE) {
      console.log('❌ Item added is unlimited/upgrade, no upsell needed');
      window.location.reload();
      return false;
    }

    // Quick synchronous check first (instant - no fetching)
    if (isExcludedFromUpsellSync(itemAdded)) {
      console.log('❌ Product excluded - no upsell');
      window.location.reload();
      return false;
    }

    // If tags aren't in the item data, fetch them now BEFORE showing modal
    if (!itemAdded.tags || itemAdded.tags.length === 0) {
      try {
        const response = await originalFetch(`/products/${itemAdded.handle}.js`);
        const productData = await response.json();

        if (productData.tags) {
          itemAdded.tags = productData.tags;

          // Check again with tags
          if (isExcludedFromUpsellSync(itemAdded)) {
            console.log('❌ Product excluded - no upsell');
            window.location.reload();
            return false;
          }
        }
      } catch (e) {
        console.log('⚠️ Could not fetch product data:', e);
      }
    }

    // Then do async checks if needed (for collection-based exclusions)
    const isExcluded = await isExcludedFromUpsell(itemAdded);

    if (isExcluded) {
      console.log('❌ Product excluded - no upsell');
      window.location.reload();
      return false;
    }

    // Don't show modal immediately - wait to check cart total first
    // (we need to know if they're eligible for free upgrade)

    // Get current cart to calculate actual total price (async)
    const cart = await getCart();
    console.log('📦 Got cart:', cart);

    if (cartHasUnlimited(cart)) {
      console.log('⚠️ Cart already has unlimited, closing modal');
      const overlay = document.getElementById('unlimited-upsell-overlay');
      if (overlay) {
        overlay.remove();
        upsellShowing = false;
      }
      return false;
    }

    // Calculate actual upsell price based on ELIGIBLE cart items only
    // (excludes Ateliers and other excluded products)
    const rawCartTotal = cart.total_price; // Total including everything
    const eligibleCartTotal = await calculateEligibleCartTotal(cart); // Only courses that count toward unlimited
    const actualUpsellPrice = UNLIMITED_PRICE - eligibleCartTotal;

    console.log('💰 Raw cart total:', rawCartTotal, '($' + rawCartTotal/100 + ')');
    console.log('💰 Eligible cart total (for upgrade calc):', eligibleCartTotal, '($' + eligibleCartTotal/100 + ')');
    console.log('💰 Actual upgrade price needed:', actualUpsellPrice, '($' + actualUpsellPrice/100 + ')');

    // Check if they're over the limit (eligible for free upgrade with savings)
    if (actualUpsellPrice <= 0) {
      const savings = Math.abs(actualUpsellPrice); // How much they save
      const cartWithoutNewItem = eligibleCartTotal - itemAdded.price; // Cart before adding this item
      const upgradePrice = UNLIMITED_PRICE - cartWithoutNewItem; // What they'd pay for unlimited

      console.log('🎉 Customer eligible for FREE upgrade!');
      console.log('💰 Eligible total:', eligibleCartTotal, '($' + eligibleCartTotal/100 + ')');
      console.log('💰 Savings:', savings, '($' + savings/100 + ')');
      console.log('💰 Cart without new item:', cartWithoutNewItem, '($' + cartWithoutNewItem/100 + ')');
      console.log('💰 Upgrade price (without new item):', upgradePrice, '($' + upgradePrice/100 + ')');

      // Show special "free upgrade" modal (it will set upsellShowing inside)
      showFreeUpgradeModal(itemAdded, savings, upgradePrice);
      return true;
    }

    // Normal upsell (not over limit yet)
    showUpsellModal(itemAdded, actualUpsellPrice, eligibleCartTotal);
    return true;
  }

  /**
   * Intercept successful cart additions
   */
  window.addEventListener('CartItemAdded', async (event) => {
    debugLog('CartItemAdded event detected:', event.detail);

    if (event.detail && event.detail.item) {
      // Reset flag from any previous upsell
      upsellShowing = false;

      // Create a placeholder overlay IMMEDIATELY to prevent page reload
      // This will be removed if product is excluded, or replaced with actual modal
      const placeholderOverlay = document.createElement('div');
      placeholderOverlay.id = 'unlimited-upsell-overlay';
      placeholderOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999998;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      document.body.appendChild(placeholderOverlay);

      // Now run async checks
      await checkAndShowUpsell(event.detail.item);
    }
  });

  /**
   * Show banner on cart page if applicable
   */
  async function showCartPageBanner() {
    // Only run on cart page
    if (!window.location.pathname.includes('/cart')) {
      return;
    }

    const cart = await getCart();

    if (!cart || !cart.items || cart.items.length === 0) {
      return;
    }

    // Check if unlimited is already in cart
    if (cartHasUnlimited(cart)) {
      debugLog('Cart has unlimited, no banner needed');
      return;
    }

    // Calculate total savings by getting unlimited (only eligible items)
    const currentTotal = cart.total_price;
    const eligibleTotal = await calculateEligibleCartTotal(cart);
    const savings = Math.max(0, UNLIMITED_PRICE - eligibleTotal);

    console.log('🛒 Cart page - Raw total:', currentTotal, 'Eligible total:', eligibleTotal, 'Savings:', savings);

    if (savings <= 0) {
      debugLog('No savings available, no banner');
      return;
    }

    // Create banner
    const banner = document.createElement('div');
    banner.id = 'unlimited-cart-banner';
    banner.style.cssText = `
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 20px;
      text-align: center;
      margin-bottom: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;

    banner.innerHTML = `
      <div style="font-size: 24px; margin-bottom: 10px;">🧘‍♀️ Offre Spéciale !</div>
      <p style="margin: 0 0 15px 0; font-size: 18px; font-weight: bold;">
        Passez à l'Illimité pour seulement ${formatPrice(savings)} de plus !
      </p>
      <p style="margin: 0 0 15px 0; font-size: 14px; opacity: 0.9;">
        Accédez à tous les cours de yoga pour le même prix
      </p>
      <button id="cart-upsell-btn" style="
        background: white;
        color: #667eea;
        border: none;
        padding: 12px 30px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        transition: transform 0.2s;
      ">
        Ajouter l'Illimité maintenant
      </button>
    `;

    // Find cart form or main cart element
    const cartForm = document.querySelector('form[action="/cart"]') ||
                     document.querySelector('.cart') ||
                     document.querySelector('main');

    if (cartForm) {
      cartForm.insertBefore(banner, cartForm.firstChild);

      // Handle button click
      const btn = document.getElementById('cart-upsell-btn');
      btn.addEventListener('mouseenter', () => {
        btn.style.transform = 'scale(1.05)';
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'scale(1)';
      });

      btn.addEventListener('click', async () => {
        btn.disabled = true;
        btn.textContent = 'Ajout en cours...';

        // Calculate upgrade price based on ELIGIBLE cart total (excludes Ateliers)
        const upgradePrice = UNLIMITED_PRICE - eligibleTotal;

        console.log('🛒 Adding upgrade from cart page - eligible total:', eligibleTotal, 'upgrade price:', upgradePrice);

        // Get the correct upgrade variant
        const upgradeVariant = await getUpgradeVariant(upgradePrice);

        if (!upgradeVariant) {
          alert('Produit de surclassement introuvable. Veuillez contacter le support.');
          btn.disabled = false;
          btn.textContent = 'Ajouter l\'Illimité maintenant';
          return;
        }

        const properties = {
          'Type': 'Surclassement Illimité',
          'Panier original': formatPrice(eligibleTotal)
        };

        const result = await addToCart(upgradeVariant.id, 1, properties);

        if (result && !result.error) {
          window.location.reload();
        } else {
          alert('Erreur lors de l\'ajout. Veuillez réessayer.');
          btn.disabled = false;
          btn.textContent = 'Ajouter l\'Illimité maintenant';
        }
      });
    }
  }

  // Initialize cart page banner
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showCartPageBanner);
  } else {
    showCartPageBanner();
  }

  console.log('✅ Unlimited Upsell Loaded');

})();
